import { render, staticRenderFns } from "./CompanyLegalTypeSelect.vue?vue&type=template&id=699641ef&scoped=true&"
import script from "./CompanyLegalTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./CompanyLegalTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699641ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
